// extracted by mini-css-extract-plugin
export var container = "_8t-0";
export var error = "_8t-9";
export var label = "_8t-5";
export var light = "_8t-6";
export var md = "_8t-3";
export var sm = "_8t-2";
export var thin = "_8t-8";
export var thinBold = "_8t-7";
export var vertical = "_8t-4";
export var xs = "_8t-1";